import educationData from './educationData';
import { useState } from 'react';
import '../styles/education.css';
import '../styles/sectionShared.css';

function EducationSection() {
  const [expandedItems, setExpandedItems] = useState({});

  const toggleExpanded = (title) => {
    setExpandedItems((prev) => ({
      ...prev,
      [title]: !prev[title],
    }));
  };

  return (
    <section className="education-section" id="utbildning" aria-labelledby="education-heading">
      <div className="section-header">
        <p className="section-overline">Utbildningar</p>
        <h2 id="education-heading">Akademisk och professionell grund</h2>
      </div>

      <div className="education-grid">
        {educationData.map((item) => (
          <article className="education-card" key={item.title}>
            <figure className="education-media">
              <img src={item.image} alt={item.title} />
            </figure>

            <div className="education-content">
              <p className="education-period">{item.period}</p>
              <h3>{item.title}</h3>
              <p>{item.description}</p>

              <div className={`education-extra ${expandedItems[item.title] ? 'is-open' : ''}`}>
                <ul>
                  {item.highlights.map((point) => (
                    <li key={point}>{point}</li>
                  ))}
                </ul>
              </div>

              <button className="education-read-more" type="button" onClick={() => toggleExpanded(item.title)}>
                {expandedItems[item.title] ? 'Visa mindre' : 'Läs mer'}
              </button>
            </div>
          </article>
        ))}
      </div>

      <p className="education-outro">
        Vill du koppla ihop profil och behov i ett konkret uppdrag?{' '}
        <a className="education-outro-link" href="#kontakt">
          Hör av dig
        </a>
        .
      </p>
    </section>
  );
}

export default EducationSection;
